export enum EMLDeliveryType {
  Unknown = "Unknown",
  Digital = "Digital",
  Physical = "Physical",
}

export const EMLDeliveryTypeList = () =>
  Object.entries(EMLDeliveryType).map(([label, value]) => {
    return { label: value, value: label };
  });
